// extracted by css-extract-rspack-plugin
export default {"wrapper":"AdCopyPage-module__wrapper--i7kgV"};